<template>
  <v-container fluid>
    <v-layout column>
      <v-card>
        <v-card-text>
          <v-flex class="mb-4">
            <div>
              <div>
                <input hidden id="fileInput" type="file" @change="previewImage" accept="image/*" />
              </div>
              <div v-if="uploadValue > 0">
                <p>
                  Progress: {{ uploadValue.toFixed() + "%" }}
                  <progress
                    id="progress"
                    :value="uploadValue"
                    max="100"
                  ></progress>
                </p>
              </div>
            </div>

            <v-avatar
              onclick="document.getElementById('fileInput').click()"
              class="mr-4"
              color="indigo"
              size="96px"
            >
              <img v-if="usuario.foto != null" :src="usuario.foto" alt="Avatar" />
              <span v-if="usuario.foto == null" class="white--text headline">{{usuario}}</span>
            </v-avatar>
            <v-btn onclick="document.getElementById('fileInput').click()">Cambiar foto de perfil</v-btn>
          </v-flex>
          <v-text-field v-model="usuario.nombre" id="email-nombre" label="Nombre"></v-text-field>
          <v-text-field v-model="usuario.apellidos" id="email-apellidos" label="Apellidos"></v-text-field>
          <v-text-field v-model="usuario.email" id="email-profile" label="Correo electrónico"></v-text-field>
          <v-subheader v-if="!emailVerified">Correo electrónico no verificado</v-subheader>
          <v-subheader v-else>Correo electrónico verificado</v-subheader>
        <v-subheader v-if="error1">{{errorMessage}}</v-subheader>
          <v-btn v-if="!emailVerified" @click="enviarCorreo">¿Reenviar correo de verificación?</v-btn>

        </v-card-text>
        <v-card-actions>
          <v-btn color="blue" :loading="loading" @click.native="update">
            <v-icon left dark>mdi-check</v-icon>Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { firebase, db, auth } from "@/firebase";

export default {
  pageTitle: "My Profile",
  data() {
    return {
      error1: false,
      errorMessage: "",
      imageData: null,
      picture: null,
      uploadValue: 0,
      loading: false,
      form: {
        firstName: "John",
        lastName: "Doe",
        contactEmail: "john@doe.com",
        avatar: "MALE_CAUCASIAN_BLOND_BEARD",
      },
      showAvatarPicker: false,
      dialog: false,
    };
  },
  components: {},
  props: {},
  methods: {
    ...mapActions(["cerrarSesion", "setUsuario", "editUsuario"]),

    previewImage(event) {
      this.uploadValue = 0;
      this.picture = null;
      this.imageData = event.target.files[0];
      this.usuario.foto = URL.createObjectURL(this.imageData);
      console.log("usuario.foto");
      console.log(this.usuario.foto);
    },
    async enviarCorreo(){
      var user = firebase.auth().currentUser;
      var temp = false;
      var tempMessage = "";
    await user.updateEmail(this.usuario.email).then(function() {
      // Update succ essful.
    console.log("exito cambio email")
    }).catch(function(error) {
    // An error happened.
  
    temp = true;
    tempMessage = error.message;
    console.log(error)
});
    if (temp){
      this.error1 = true;
      this.errorMessage = tempMessage;
    }
    
      console.log(auth)
      var user = auth.currentUser;
      console.log(user)
      user.sendEmailVerification().then(function() {
      // Email sent.
          }).catch(function(error) {
  // An error happened.
      });
    },

    update() {
      if (this.usuario.email != auth.currentUser.email){
        this.enviarCorreo();
      }
      if (this.imageData != null) {
        this.picture = null;
        const storageRef = firebase
          .storage()
          .ref(`${"profile/" + this.usuario.uid}`)
          .put(this.imageData);
        storageRef.on(
          `state_changed`,
          (snapshot) => {
            this.uploadValue =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log(
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            );
          },
          (error) => {
            console.log(error.message);
          },
          () => {
            this.uploadValue = 100;
            storageRef.snapshot.ref.getDownloadURL().then((url) => {
              this.picture = url;
              this.usuario.foto = url;
              console.log(this.picture);
              this.editUsuario(this.usuario);
            });
          }
        );
      } else {
        this.editUsuario(this.usuario);
      }
    },
    async update1() {
      if (this.imageData != null) {
        await this.onUpload();
      }
    },
  },
  created() {
    this.emailVerified = auth.currentUser.emailVerified;
    this.usuario.email = auth.currentUser.email;
  },
  
  computed: {
    ...mapState(["usuario"]),
  },
};
</script>
